// extracted by mini-css-extract-plugin
export default {"col_4":"Cardpage_col_4__RVeo4","clientlogocard":"Cardpage_clientlogocard__aj0fW","mobileview":"Cardpage_mobileview__vzT2X","bigImgWrapper":"Cardpage_bigImgWrapper__PMZXM"};